import { render, staticRenderFns } from "./TestReceiptSlip.vue?vue&type=template&id=28f7e4a2&scoped=true&"
import script from "./TestReceiptSlip.vue?vue&type=script&lang=js&"
export * from "./TestReceiptSlip.vue?vue&type=script&lang=js&"
import style0 from "./TestReceiptSlip.vue?vue&type=style&index=0&id=28f7e4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f7e4a2",
  null
  
)

export default component.exports